/**
 * timeHorizons.ts — FILTER-1 (Fix-Wave-7)
 *
 * Single source of truth for time_horizon options. Both OutcomeFormDialog
 * (create/edit form) and OutcomesPage (filter dropdown) import from here so
 * that planning_cycle filtering cannot drift between the two.
 *
 * PRD §1 (planning_cycle config):
 *   - planning_cycle='quarterly' → hide 'trimester'
 *   - planning_cycle='trimester' → hide 'quarterly'
 *   - undefined / other → show all
 */

export interface TimeHorizonOption {
  value: string;
  label: string;
}

/** Full set of 7 time_horizon values (DOGFOOD-5 added daily + weekly). */
export const TIME_HORIZON_OPTIONS: TimeHorizonOption[] = [
  { value: 'daily',     label: 'daily' },
  { value: 'weekly',    label: 'weekly' },
  { value: 'monthly',   label: 'monthly' },
  { value: 'trimester', label: 'trimester' },
  { value: 'quarterly', label: 'quarterly' },
  { value: 'annual',    label: 'annual' },
  { value: 'ongoing',   label: 'ongoing' },
];

/**
 * Returns the subset of TIME_HORIZON_OPTIONS visible for the given
 * planning_cycle setting. Memoized by the caller (useMemo).
 */
export function visibleTimeHorizons(planningCycle?: string): TimeHorizonOption[] {
  if (planningCycle === 'quarterly') {
    return TIME_HORIZON_OPTIONS.filter((o) => o.value !== 'trimester');
  }
  if (planningCycle === 'trimester') {
    return TIME_HORIZON_OPTIONS.filter((o) => o.value !== 'quarterly');
  }
  return TIME_HORIZON_OPTIONS;
}
